// import { getToken } from '@/utils/cookies'

export interface UserState {
  token: string;
  name: string;
  avatar: string;
  introduction: string;
  roles: string[];
  email: string;
  userId: number;
  username: string;
}

export const state: UserState = {
  token: '',
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  email: '',
  userId: 0,
  username: ''
}
